class UtmSources {
  constructor() {
    this.loadPrivacyFeatures();
  }

  loadPrivacyFeatures() {
    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1",
        },
      ],
      this.checkConsent.bind(this),
      (error) => {
        if (error) {
          console.error(error);
        }
      }
    );
  }

  checkConsent() {
    if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
      this.listeners();
    } else {
      document.addEventListener("visitorConsentCollected", (event) => {
        if (event.detail && event.detail.analyticsAllowed) {
          this.listeners();
        }
      });
    }
  }

  listeners() {
    const searchParams = new URLSearchParams(location.search);
    const utmParamKeys = [
      "utm_campaign",
      "utm_content",
      "utm_term",
      "utm_medium",
      "utm_source",
    ];
    const paramsToKeep = [];
    const cookiePrefix = "param_";
    let utmParams = "";
    let removeEmptyParams = false;
    let firstParam = true;

    utmParamKeys.forEach((utmParamKey) => {
      const paramInSearch = searchParams.get(utmParamKey);

      if (paramInSearch) {
        this.setCookie(`${cookiePrefix}${utmParamKey}`, paramInSearch);
        removeEmptyParams = true;
        paramsToKeep.push(utmParamKey);
      }
    });

    if (removeEmptyParams) {
      utmParamKeys.forEach((utmParamKey) => {
        if (!paramsToKeep.includes(utmParamKey)) {
          this.removeCookie(`${cookiePrefix}${utmParamKey}`);
        }
      });
    }

    const customerNoteSource = document.querySelector(
      'input[name="customer[note][Source]"]'
    );

    if (!customerNoteSource) return;

    let existingParams = new URLSearchParams(window.location.href);
    if (window.location.href.includes("?")) {
      existingParams = new URLSearchParams(window.location.href.split("?")[1]);
      firstParam = false;
    }

    utmParamKeys.forEach((utmParamKey) => {
      const paramInCookies = this.getCookie(`${cookiePrefix}${utmParamKey}`);

      if (paramInCookies && !existingParams.get(utmParamKey)) {
        utmParams += `${
          firstParam ? "?" : "&"
        }${utmParamKey}=${paramInCookies.replace(cookiePrefix, "")}`;
        firstParam = false;
      }
    });

    const utmCampaignUrl = encodeURI(`${window.location.href}${utmParams}`);
    customerNoteSource.value = utmCampaignUrl;
  }

  setCookie(key, value) {
    document.cookie = `${key}=${encodeURI(value)};max-age=86400;`;
  }

  getCookie(key) {
    let name = `${key}=`;
    let decodedCookie = decodeURIComponent(document.cookie);
    let cookies = decodedCookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];

      while (cookie.charAt(0) == " ") {
        cookie = cookie.substring(1);
      }

      if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }

    return false;
  }

  removeCookie(key) {
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
  }
}
document.addEventListener("DOMContentLoaded", () => {
  new UtmSources();
});
